import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { DialogueVo } from "../data/dialogue/dialoguevo";

@Injectable({
  providedIn: "root",
})
export class GridColumnUserService {
  constructor(private http: HttpClient) {}

  saveUserGridColumns(userId, gridName, vos): Observable<DialogueVo> {
    return this.http.post<DialogueVo>(
      `/service/gridcolumns/${userId}/${gridName}`,
      vos
    );
  }
}
